export const REGEX_ALPHABETICAL_OR_NUMERIC = /^[a-zA-Z0-9]+$/;
export const REGEX_BITCOIN_WALLET_ADDRESS = /^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$/;
export const REGEX_NUMERIC = /\d+/;
export const REGEX_TETHER_WALLET_ADDRESS = /T[A-Za-z1-9]{33}/;
